export const buildEmailChangeBaseUrl = () =>
  `${window.location.origin}/account/change-email/`

export const buildEmailValidationBaseUrl = () =>
  `${window.location.origin}/account/verify-email/`

export const buildUserRegistrationUrl = () =>
  `${window.location.origin}/account/register/`

export const buildPasswordResetUrl = () =>
  `${window.location.origin}/account/password-reset/`

export const buildNewsletterUnsubscribeUrl = (email: string) =>
  `${window.location.origin}/newsletter/unsubscribe/?email=${encodeURIComponent(
    email
  )}`
